"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function nullDefault(value, valueIfNull) {
    return value === null ? valueIfNull : value;
}
exports.default = nullDefault;
//# sourceMappingURL=nullDefault.js.map